import { useEffect, useState } from 'react';
import { doc, getDoc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import { useAuth } from '../firebase/useAuth';
import { CATEGORIES } from '../data/categories';
import { REACTION_EMOJIS } from '../data/reactions';
import styles from './EmojiPicker.module.css';

export default function EmojiPicker({ ownerUserId, entryId, categoryKey, onClose }) {
  const { user } = useAuth();
  const [myEmoji, setMyEmoji] = useState(null);
  const [loading, setLoading] = useState(true);
  const cat = CATEGORIES.find(c => c.key === categoryKey);

  const reactionDocId = `${user.uid}_${categoryKey}`;
  const reactionRef = doc(db, 'users', ownerUserId, 'entries', entryId, 'reactions', reactionDocId);

  useEffect(() => {
    getDoc(reactionRef).then(snap => {
      setMyEmoji(snap.exists() ? snap.data().emoji : null);
      setLoading(false);
    });
  // eslint-disable-next-line
  }, []);

  const handleSelect = async (emoji) => {
    if (myEmoji === emoji) {
      await deleteDoc(reactionRef);
    } else {
      await setDoc(reactionRef, {
        categoryKey,
        emoji,
        authorId: user.uid,
        authorName: user.displayName || user.email || 'Anonymous',
        at: serverTimestamp(),
      });
    }
    onClose();
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.sheet}
        style={cat ? { '--accent': `var(${cat.accentVar})` } : undefined}
        onClick={e => e.stopPropagation()}
      >
        <p className={styles.title}>React</p>
        {loading ? (
          <div className={styles.emojis}>…</div>
        ) : (
          <div className={styles.emojis}>
            {REACTION_EMOJIS.map(emoji => (
              <button
                key={emoji}
                className={`${styles.emojiBtn} ${myEmoji === emoji ? styles.selected : ''}`}
                onClick={() => handleSelect(emoji)}
              >
                {emoji}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
